import { Component, Input, OnInit } from '@angular/core';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'road-risk-full-info',
  templateUrl: './road-risk-full-info.component.html',
  styleUrls: ['./road-risk-full-info.component.scss'],
})
export class RoadRiskFullInfoComponent implements OnInit {
  @Input() roadRiskInfo: any;

  @Input() roadRiskWithRegTrademark: string;
  @Input() riskRatingColors: any;
  @Input() riskRatings: any;

  riskProfileName: string = '';

  constructor(public cService: CommonService) {}

  ngOnInit() {
    if (this.roadRiskInfo) {
      this.riskProfileName = this.cService.readyTranslations.courses[this.roadRiskInfo.name];
      if (!this.riskProfileName) {
        this.riskProfileName = this.roadRiskInfo.name;
      }
    }
  }
}
